export default class Filters {
	constructor(biblia) {
		this.biblia = biblia;
	}

	initialize() {
		this.openTestamentSelect();
		this.setSelectedTestament();
		this.setDefaultTestamentOption();
	}

	openTestamentSelect() {
		const context = document.querySelector('#biblia-online #testament-filter');
		const select = document.querySelector('#biblia-online #testament-filter > .filter-select');
		const options = document.querySelector('#biblia-online #testament-filter > .filter-options');

		select.addEventListener('click', () => {
			options.classList.toggle('active');
		});

		options.addEventListener('click', (e) => {
			if (e.target.classList.contains('option')) {
				options.classList.remove('active');
			}
		});

		document.addEventListener('click', (e) => {
			if (!context.contains(e.target)) {
				options.classList.remove('active');
			}
		});
	}

	setSelectedTestament() {
		const options = document.querySelectorAll('#biblia-online #testament-filter > .filter-options .option');
		options.forEach(option => {
			option.addEventListener('click', () => {
				this.selectTestamentOption(option);
			});
		});
	}

	setDefaultTestamentOption() {
		const defaultOption = document.querySelector('#biblia-online #testament-filter > .filter-options .option[data-value="default"]');
		this.selectTestamentOption(defaultOption);
	}

	selectTestamentOption(option) {
		if (!option.classList.contains('selected')) {
			const label = document.querySelector('#biblia-online .selected-label');
			label.innerText = option.innerText;

			this.clearSelectedTestament();
			this.filterTestamentBooks(option.getAttribute('data-value'));

			option.classList.add('selected');
			this.setSelectedFilters(option);
		}
	}

	clearSelectedTestament() {
		const options = document.querySelectorAll('#biblia-online #testament-filter > .filter-options > div > .option');
		const selected = document.querySelector('#biblia-online #testament-filter > .filter-selected');

		selected.innerHTML = '';

		options.forEach(option => {
			option.classList.remove('selected')
		});
	}

	setSelectedFilters(selected) {

		if (selected.getAttribute('data-value') == 'default') {
			return;
		}

		const section = document.querySelector('#biblia-online #testament-filter > .filter-selected');
		const div = document.createElement('div');

		const span = document.createElement('span');
		span.innerText = selected.innerText;

		const i = document.createElement('i');
		i.classList.add('fa-solid', 'fa-xmark');

		i.addEventListener('click', () => {
			selected.classList.remove('selected');

			div.remove();
			this.setDefaultTestamentOption();
		});

		div.appendChild(span);
		div.appendChild(i);

		section.innerHTML = '';
		section.appendChild(div)
	}

	handlerTestamentBooksFilter(testament) {
		const options = document.querySelectorAll('#biblia-online #testament-filter > .filter-options > div > .selected');

		if(options.length) {
			this.filterTestamentBooks(testament);
		} else {
			this.filterTestamentBooks();
		}
	}

	filterTestamentBooks(testament = false) {
		const books = document.querySelectorAll('#biblia-online .list > div');
		books.forEach(book => {
			if (!testament || testament === 'default') {
				book.classList.remove('filtered');

			} else {
				if (book.getAttribute('data-testament') === testament) {
					book.classList.remove('filtered');
				} else {
					book.classList.add('filtered');
				}
			}
		});
	}

	getImagesUrl() {
		const url = document.querySelector('#parresia-image-url');
		return url?.value || '';
	}
}
